import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import styles from './MarketingScreenNew.module.css';
import { useRef } from 'react';
import { Swiper as SwiperType } from 'swiper/types';

const MarketingTestimonials = () => {
	const swiperRef = useRef<SwiperType | null>(null);
	const handleMouseEnter = () => {
		swiperRef.current?.autoplay?.stop();
	};

	const handleMouseLeave = () => {
		swiperRef.current?.autoplay?.start();
	};

	return (
		<>
			<div className={styles.SecTitle}>Testimonials</div>
			<div className={styles.TestiContainer}>
				<Swiper
					onSwiper={(swiper) => {
						swiperRef.current = swiper;
					}}
					spaceBetween={16}
					slidesPerView={2}
					autoplay={{
						delay: 3000,
						disableOnInteraction: false,
					}}
					loop={false}
					pagination={{
						clickable: true,
					}}
					modules={[Pagination, Autoplay]}
					className="TestiSwiper"
				>
					<SwiperSlide onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
						<div className={styles.TestiCard}>
							<div className={styles.TestiCardBio}>
								<div className={styles.TestiCardIcon}>R</div>
								<div className={styles.TestiCardName}>
									Ravi Malhotra <div className={styles.TestiCardOcc}>Real Estate Consultant, Delhi</div>
								</div>
							</div>
							<div className={styles.TestiCardContent}>
								“I can am able message hundreds of buyers and start getting replies within minutes. The templates are really helping my team members avoid errors in messages and make
								the process very quick.”
							</div>
							<div className={styles.TestiCardHighlight}>Saved 10+ hours every week.</div>
						</div>
					</SwiperSlide>
					<SwiperSlide onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
						<div className={styles.TestiCard}>
							<div className={styles.TestiCardBio}>
								<div className={styles.TestiCardIcon}>S</div>
								<div className={styles.TestiCardName}>
									Sneha Kapoor <div className={styles.TestiCardOcc}>Builder, Mumbai</div>
								</div>
							</div>
							<div className={styles.TestiCardContent}>
								“The engagement rate on WhatsApp is unbeatable. We saw a 40% spike in our listing engagement after using WhatsApp for our latest launch.”
							</div>
							<div className={styles.TestiCardHighlight}>Increased engagement on property listings by 30%</div>
						</div>
					</SwiperSlide>
					<SwiperSlide onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
						<div className={styles.TestiCard}>
							<div className={styles.TestiCardBio}>
								<div className={styles.TestiCardIcon}>Z</div>
								<div className={styles.TestiCardName}>
									Zubair Sheikh <div className={styles.TestiCardOcc}>Channel Partner, Hyderabad</div>
								</div>
							</div>
							<div className={styles.TestiCardContent}>“The CRM integration is smooth and simple. I can track who received the message and follow up right after – very effective!”</div>
							<div className={styles.TestiCardHighlight}>Increased conversion by 18%</div>
						</div>
					</SwiperSlide>
				</Swiper>
			</div>
		</>
	);
};

export default MarketingTestimonials;
